export default class ChecklistFilters {
    checklistEntityKey = '';
    name = '';
}